import { ReactNode } from 'react';

import { TActiveOptions, TBroadcastActiveOptions, TRangeActiveOptions } from './active-options';
import { TFacetsResult, useBroadcastFacets, useMentionFacets } from './use-mention-facets';

type ActiveFacetsProps = {
  activeOptions: TActiveOptions;
  children: (facets: TFacetsResult) => ReactNode;
};

function RangeFacets({
  activeOptions,
  children,
}: {
  activeOptions: TRangeActiveOptions;
  children: ActiveFacetsProps['children'];
}) {
  return <>{children(useMentionFacets(activeOptions))}</>;
}

function BroadcastFacets({
  activeOptions,
  children,
}: {
  activeOptions: TBroadcastActiveOptions;
  children: ActiveFacetsProps['children'];
}) {
  return <>{children(useBroadcastFacets(activeOptions))}</>;
}

/**
 * Hands the workspace and tag ids of the active source to its children: requested by range,
 * or carried by a broadcast source with no request.
 */
export function ActiveFacets({ activeOptions, children }: ActiveFacetsProps) {
  return activeOptions.source === 'programBroadcast' ? (
    <BroadcastFacets activeOptions={activeOptions}>{children}</BroadcastFacets>
  ) : (
    <RangeFacets activeOptions={activeOptions}>{children}</RangeFacets>
  );
}
